import { styled } from '@clickcease/cc-client-components-lib'

export const InsightsWidgetWrapper = styled('div', {
  marginTop: '20px',
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
})
export const InsightsWidgetChartWrapper = styled('div', {
  backgroundColor: '$white',
  borderRadius: '14px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  padding: '20px',
  flex: 1,
})

export const InsightsWidgetChartTitleSection = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
})

export const InsightsWidgetChartTitle = styled('div', {
  fontSize: '$lg',
  fontWeight: 600,
  padding: '8px 8px',
})

export const SeriesToggleContainer = styled('div', {
  gap: '6px',
  display: 'flex',
  justifyContent: 'end',
  variants: {
    chart1: {
      true: {
        width: '575px',
      },
    },
  },
})

export const SeriesToggleItem = styled('label', {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  fontSize: '12px',
  gap: '5px',
})
